module.exports = __webpack_public_path__ + "img/horizontal_6_6_9016.b49ecf60.png";